import { render, staticRenderFns } from "./wheel-spin-event.vue?vue&type=template&id=6fcc5c85&scoped=true"
import script from "./wheel-spin-event.vue?vue&type=script&lang=js"
export * from "./wheel-spin-event.vue?vue&type=script&lang=js"
import style0 from "./wheel-spin-event.vue?vue&type=style&index=0&id=6fcc5c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcc5c85",
  null
  
)

export default component.exports